import { ScrollManager } from "@/components/ui";
import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { LandingTopbar } from "./components";

// Lazy load the footer component
const LandingPageFooter = lazy(() =>
  import("./components").then((module) => ({
    default: module.LandingPageFooter,
  }))
);

export function LandingLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <ScrollManager />
      <LandingTopbar className="flex-none" />
      <main className="flex-1 relative">
        <Outlet />
      </main>
      <Suspense fallback={<div className="h-16" />}>
        <LandingPageFooter />
      </Suspense>
    </div>
  );
}

export default LandingLayout;
